function PaymentPortalLink() {

  return (<a
    href="https://billing.stripe.com/p/login/fZeaHYfX2dxD2g8288"
    className={`flex
      ring ring-1 ring-[#FFFFFF]/[0.4]
      rounded-full
      h-[2.5em]
      justify-center items-center
      share-button
      w-full
      my-[50px]`}
  >
    Manage account
  </a>)
}

export default PaymentPortalLink
